import cgu from '../../pdf/CGU.pdf';
import confidentialite from '../../pdf/politique.pdf';

export default function UsageConditions() {
    return (
      <div className="px-6 conditionDutilisation">
      <div style={{ fontFamily: 'Open Sans', fontWeight: 400 }}>
        <label htmlFor="conditions" className="conditionlabel">
          En continuant vous acceptez les
          <a href={cgu} target="_blank" className="cgu" rel="noreferrer">
            {' '}
            conditions Générales d'Utilisation{' '}
          </a>{' '}
          et la{' '}
          <a
            className="cgu"
            href={confidentialite}
            target="_blank"
            rel="noreferrer"
          >
            politique de confidentialité
          </a>{' '}
          de PikkoPay
        </label>
      </div>
    </div>
    )
  }